import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="output-items--table"
export default class extends Controller {
  static targets = [
    "addSelectedBtn",
    "removeSelectedBtn",
    "addAllBtn",
    "removeAllBtn",
    "candidateTbody",
    "selectedTbody"
  ]

  connect() {
  }

  addItem() {
    if (!this.hasCandidateTbodyTarget || !this.hasSelectedTbodyTarget) return

    const candidateRows = this.candidateTbodyTarget.querySelectorAll("tr")
    let addedCount = 0

    candidateRows.forEach(row => {
      const checkbox = row.querySelector("input[type='checkbox']")
      if (!checkbox || !checkbox.checked) return

      const isAlreadyAdded = row.querySelector(".chip") !== null
      if (!isAlreadyAdded) {
        this.buildSelectedRow(row, this.selectedTbodyTarget)
        this.addRegisteredChip(row)
        addedCount++
      }
      checkbox.checked = false
    })

    if (addedCount > 0) this.reindexSelectedOrders()
  }

  removeItem() {
    if (!this.hasCandidateTbodyTarget || !this.hasSelectedTbodyTarget) return

    const selectedRows = this.selectedTbodyTarget.querySelectorAll("tr")
    let removedCount = 0

    selectedRows.forEach(row => {
      const checkbox = row.querySelector("input[type='checkbox']")
      if (!checkbox || !checkbox.checked) return

      const key = row.dataset.key
      row.remove()
      removedCount++

      if (key) {
        this.removeRegisteredChip(key, this.candidateTbodyTarget)
      }
    })

    if (removedCount > 0) this.reindexSelectedOrders()
  }

  addAllItems() {
    if (!this.hasCandidateTbodyTarget || !this.hasSelectedTbodyTarget) return

    const candidateRows = this.candidateTbodyTarget.querySelectorAll("tr")
    let addedCount = 0

    candidateRows.forEach(row => {
      const isAlreadyAdded = row.querySelector(".chip") !== null
      if (!isAlreadyAdded) {
        this.buildSelectedRow(row, this.selectedTbodyTarget)
        this.addRegisteredChip(row)
        addedCount++
      }
      
      const checkbox = row.querySelector("input[type='checkbox']")
      if (checkbox) checkbox.checked = false
    })

    if (addedCount > 0) this.reindexSelectedOrders()
  }

  removeAllItems() {
    if (!this.hasCandidateTbodyTarget || !this.hasSelectedTbodyTarget) return

    const selectedRows = this.selectedTbodyTarget.querySelectorAll("tr")
    
    selectedRows.forEach(row => {
      const key = row.dataset.key
      row.remove()
      if (key) {
        this.removeRegisteredChip(key, this.candidateTbodyTarget)
      }
    })
    
    this.reindexSelectedOrders()
  }

  buildSelectedRow(candidateRow, selectedTbody) {
    const key = candidateRow.dataset.key || `key-${Date.now()}-${Math.random().toString().slice(2, 6)}`
    candidateRow.dataset.key = key 

    const category = candidateRow.cells[1] ? candidateRow.cells[1].innerText.trim() : ""
    const sourceId = candidateRow.dataset.sourceId || "1"
    const allowanceId = candidateRow.dataset.allowanceId || "0"
    
    let outputName = ""
    if (candidateRow.cells[4]) {
      outputName = candidateRow.cells[4].innerText.replace("登録済", "").trim()
    }

    const tr = document.createElement("tr")
    tr.dataset.key = key
    
    tr.innerHTML = `
      <td><input type="checkbox" /></td>
      <td></td>
      <td>${category}</td>
      <td>${sourceId}</td>
      <td>${allowanceId}</td>
      <td>
        <input class="inline-edit" type="text" value="${outputName}" />
      </td>
      <td class="check">✓</td>
    `
    selectedTbody.appendChild(tr)
  }

  addRegisteredChip(candidateRow) {
    const td = candidateRow.cells[4]
    if (td && !td.querySelector(".chip")) {
      td.insertAdjacentHTML('beforeend', ' <span class="chip">登録済</span>')
    }
  }

  removeRegisteredChip(key, candidateTbody) {
    const candidateRow = candidateTbody.querySelector(`tr[data-key="${key}"]`)
    if (candidateRow) {
      const chip = candidateRow.querySelector(".chip")
      if (chip) chip.remove()
    }
  }

  reindexSelectedOrders() {
    if (!this.hasSelectedTbodyTarget) return
    const selectedRows = this.selectedTbodyTarget.querySelectorAll("tr")
    selectedRows.forEach((row, index) => {
      const orderCell = row.cells[1]
      if (orderCell) {
        orderCell.innerText = index + 1
      }
    })
  }
}
